export const NOT_SURE_ANSWERED_QUESTIONS_STORAGE_KEY = 'client_im_not_sure';
